import { Notice } from '@/components/ui/Notice'
import { Section, SectionHeading } from '@/components/ui/Section'
import { CahayaGrid } from '@/features/cahaya/CahayaGrid'
import { useDocumentMeta } from '@/hooks/useDocumentMeta'
import { useI18n } from '@/i18n'

export function CahayaPage() {
  const { t } = useI18n()
  useDocumentMeta({ title: t.cahaya.heading, description: t.cahaya.lead })

  return (
    <Section>
      <SectionHeading eyebrow={t.cahaya.eyebrow} title={t.cahaya.heading} lead={t.cahaya.lead} />
      <div className="mt-6">
        <Notice>{t.cahaya.draftNotice}</Notice>
      </div>
      <div className="mt-10">
        <CahayaGrid showDeliverables />
      </div>
    </Section>
  )
}
